import Dict from '@/utils/dict-utils'

// 供应商入库状态
export const listedStatusDict = new Dict({
  NORMAL: {
    label: '在库',
    type: 'success',
    value: 0
  },
  REMOVE: {
    label: '已移出',
    type: 'danger',
    value: 1
  }
})

// 共享库分类
export const shareLibraryTypeDict = new Dict({
  ALL: { label: '共享库', value: -1 },
  COMPANY: { label: '共享公司', value: 0 },
  GROUP: { label: '共享公司下供应商分组', value: 1 }
})

// 供应商库类型
export const categoryTypeDict = new Dict({
  COMPANY: { label: '企业供应商库', value: 1, alias: 'company' },
  SHARE: { label: '共享供应商库', value: 2, alias: 'share' }
})

// 移出状态
export const listedRecordStatusDict = new Dict({
  REVOKE: { label: '撤销', value: 0 },
  REMOVE: { label: '移出', value: 1 }
})

// 评分调整
export const scoreAdjustDict = new Dict({
  INCREASE: { label: '增加', value: '+' },
  REDUCE: { label: '减少', value: '-' }
})

// 证照状态
export const certStatusDict = new Dict({
  NORMAL: { label: '正常', value: 1, type: 'primary' },
  LOSE: { label: '失效', value: 0, type: 'info' }
})

// 评级项
export const gradeDict = new Dict({
  A: { label: 'A', value: 'A' },
  B: { label: 'B', value: 'B' },
  C: { label: 'C', value: 'C' },
  D: { label: 'D', value: 'D' },
  E: { label: 'E', value: 'E' },
  F: { label: 'F', value: 'F' }
})

// 是否启用评分规则
export const enableDict = new Dict({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 0 }
})

// 是否授权代理机构使用企业供应商
export const isAllowUseSrmDict = new Dict({
  YES: { label: '授权代理机构使用', value: 1 },
  NO: { label: '不授权代理机构使用', value: 0 }
})

// 供应商入库方式
export const storageModeDict = new Dict({
  RECRUITMENT: { label: '供应商招募', value: 0 },
  DIRECT: { label: '直接入库', value: 1 }
})
